import type React from "react";
import type { HighlightsArrowType } from "./types";
import type { ArrowGlyphShape } from "./parts/ArrowGlyph";

/**
 * Estilo inline das setas, compartilhado pelo carrossel e pelo modal — é o que
 * faz a escolha de "Tipo de seta" (accordion Formato) valer nos dois lugares.
 *
 * Fica em módulo próprio, e não num `styled`, porque as variantes mudam borda,
 * fundo e cor do glifo ao mesmo tempo: um objeto de estilo descreve isso de
 * forma mais direta do que blocos CSS condicionais.
 */

/** Variantes SEM disco: a área do botão encolhe para ficar justa ao glifo. */
const BARE_TYPES: HighlightsArrowType[] = ["chevronOnly", "arrowShort", "arrow"];

export const isBareArrow = (type: HighlightsArrowType): boolean =>
  BARE_TYPES.includes(type);

/** Qual glifo cada tipo desenha — só as duas setas têm haste. */
export const arrowGlyphShape = (type: HighlightsArrowType): ArrowGlyphShape => {
  if (type === "arrow") return "arrow";
  if (type === "arrowShort") return "arrowShort";
  return "chevron";
};

export const arrowStyle = (
  type: HighlightsArrowType,
  color: string,
): React.CSSProperties => {
  if (type === "filled") {
    return {
      backgroundColor: color,
      borderColor: color,
      borderWidth: 1,
      borderStyle: "solid",
      /*
       * O glifo acompanha o FUNDO DA SEÇÃO, não um branco fixo: o disco é
       * pintado com a cor da navegação (hoje `--text-title`), então numa paleta
       * de fundo escuro — título branco — o branco sobre branco fazia a seta
       * virar um bloco sólido sem chevron.
       */
      color: "var(--general-background, #FFFFFF)",
    };
  }

  /*
   * Sem disco, a área do botão encolhe (ver `isBareArrow` nos styles): mantendo
   * os 40px do disco, os dois glifos ficavam separados por uma faixa vazia de
   * ~80px e o par deixava de ser lido como um controle só.
   */
  if (isBareArrow(type)) {
    return { backgroundColor: "transparent", border: "none", color };
  }

  return {
    backgroundColor: "transparent",
    borderColor: color,
    borderWidth: 1,
    borderStyle: "solid",
    color,
  };
};
